import { TextInput, TextProps } from '../index';
import React, { useCallback } from 'react';
import { MaskType } from '../../models';
import Inputmask from 'inputmask';

export const EmailInput = (props: TextProps) => {
    const applyMask = useCallback((node: HTMLInputElement) => {
        if (!node) {
            return;
        }
        Inputmask({
            mask: MaskType.Email,
            insertMode: false,
            placeholder: '',
            insertModeVisual: true,
            shiftPositions: false,
            clearMaskOnLostFocus: true,
        }).mask(node);
    }, []);

    return <TextInput {...props} ref={applyMask} />;
};
